import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Parse from 'parse';
import PublicRoutes from './PublicRoutes';
import PrivateRoutes from './PrivateRoutes';
import {RootState} from 'state';
import {logout} from 'state/auth';

export const Routes: React.FC = () => {
  const dispatch = useDispatch();
  let currentUser;
  //check if parse is initialized
  if (!Parse.applicationId) {
    Parse.initialize(
      process.env.REACT_APP_PARSE_APP_ID!,
      process.env.REACT_APP_PARSE_JS_KEY!,
    );
    Parse.serverURL = process.env.REACT_APP_PARSE_URL!;
  } else {
    currentUser = Parse.User.current();
  }

  const {isLogged} = useSelector((state: RootState) => state.auth);

  if (isLogged) {
    if (currentUser) {
      return <PrivateRoutes />;
    } else {
      dispatch(logout());
    }
  }

  return <PublicRoutes />;
};

export default Routes;
